import { render, staticRenderFns } from "./WorkerForm.vue?vue&type=template&id=108bfe82"
import script from "./WorkerForm.vue?vue&type=script&lang=js"
export * from "./WorkerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports